import PropTypes from 'prop-types'

import TextLink from './TextLink'

import Image from '~components/Image'
import { config } from '~helpers/config'

const GoogleStaticMap = ({ location, ...rest }) => {
  const width = 640
  const height = 480

  const { address1, address2, city, state, zip } = location

  const urlEncodedAddress = encodeURIComponent(
    Object.values({ address1, address2, city, state, zip })
  )

  return (
    <TextLink
      href={`https://maps.google.com/?q=${urlEncodedAddress}`}
      css={{
        paddingBottom: `${(height / width) * 100}%`,
        marginBottom: 0,
        position: 'relative',
        display: 'block',
        height: 0,
        overflow: 'hidden',

        img: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        },
      }}
      title="View on Google Maps"
      {...rest}
    >
      <Image
        src={`https://maps.googleapis.com/maps/api/staticmap?sensor=false&size=${width}x${height}&zoom=15&scale=2&center=${urlEncodedAddress}&style=feature:water|element:geometry|color:0xe9e9e9|lightness:17&style=feature:landscape|element:geometry|color:0xf5f5f5|lightness:20&style=feature:road.highway|element:geometry.fill|color:0xffffff|lightness:17&style=feature:road.highway|element:geometry.stroke|color:0xffffff|lightness:29|weight:0.2&style=feature:road.arterial|element:geometry|color:0xffffff|lightness:18&style=feature:road.local|element:geometry|color:0xffffff|lightness:16&style=feature:poi|element:geometry|color:0xf5f5f5|lightness:21&style=feature:poi.park|element:geometry|color:0xdedede|lightness:21&style=element:labels.text.stroke|visibility:on|color:0xffffff|lightness:16&style=element:labels.text.fill|saturation:36|color:0x333333|lightness:40&style=feature:transit|element:geometry|color:0xf2f2f2|lightness:19&style=feature:administrative|element:geometry.fill|color:0xfefefe|lightness:20&style=feature:administrative|element:geometry.stroke|color:0xfefefe|lightness:17|weight:1.2&key=${config.googleMapsKey}&format=png&visual_refresh=true&markers=size:large%7Cshadow:false%7C${urlEncodedAddress}`}
      />
    </TextLink>
  )
}

GoogleStaticMap.propTypes = {
  location: PropTypes.object.isRequired,
}

export default GoogleStaticMap
